import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    width: 100%;
    height: 100%;
    padding-top: 50px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

// background color
// mouse drag move
// tattoo image
// interact - information popup
const Presenter = () => (
    <Container>
        <div>CATLOVER▼</div>
    </Container>
);

export default Presenter;
